<mibi-single-center-card-layout cardTitle="Passwort zurücksetzen">
    <mibi-reset-container mibi-card-content></mibi-reset-container>
</mibi-single-center-card-layout>
